export default __webpack_public_path__ + "static/media/elevate-gry-poster-1.a40ae6aa.jpg";